import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  "aria-hidden": "true",
  class: "h-6 w-6",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13.682 10.622 20.24 3h-1.554l-5.693 6.618L8.445 3H3.2l6.876 10.007L3.2 21h1.554l6.012-6.989L15.57 21h5.244l-7.131-10.378Zm-2.128 2.474-.697-.997-5.543-7.93H7.7l4.473 6.4.697.996 5.815 8.319H16.3l-4.745-6.788Z" }, null, -1)
  ]))]))
}
export default { render: render }